<template>
  <div class="add-status">
    <p>
      <b>{{ status.name }}</b>
      {{ $tr('settings.statuses.hasBeenDeleted') }}
    </p>
    <div class="button-iconed">
      <div class="undo-icon"></div>
      <button class="undo" @click="undoFinallyDelete">{{ $tr('settings.statuses.undo') }}</button>
    </div>
    <button class="cancel" @click="finallyDelete">{{ $tr('settings.statuses.close') }}</button>
  </div>
</template>

<script>
export default {
  name: 'deleted-status',

  props: {
    status: {
      type: Object,
      required: true
    }
  },

  methods: {
    undoFinallyDelete () {
      this.$emit('undoFinallyDelete')
    },

    finallyDelete () {
      this.$emit('finallyDelete')
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/styles/colors.scss';
@import '@/styles/variables.scss';

.add-status {
  width: 50%;
  padding: 20px;
  background: #f1f2f2;
  box-sizing: border-box;
  border-bottom: 1px solid #dddddd;
  display: flex;
  min-width: 500px;

  p {
    font-size: 16px;
    margin: 0;
    padding: 0;
    color: $text-color;
    width: 71%;
    max-width: 430px;
  }

  button {
    border: none;
    background: transparent;
    color: $green;
    font-weight: 500;
    font-size: 16px;
    padding: 0;

    &:hover {
      cursor: pointer;
    }
  }

  .button-iconed {
    display: flex;
    align-items: center;
    margin-left: auto;

    &:hover {
      cursor: pointer;
    }

    .undo-icon {
      height: 8px;
      width: 17px;
      background: url('/static/images/elements/undo.svg') center no-repeat;
      background-size: contain;
      margin-right: 4px;
    }
  }

  .cancel {
    margin-left: 18px;
  }
}
</style>
